export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6778.de1aa880.jpg";